import React, {useMemo, useState} from "react";
import styles from "../../../Tab.module.scss";
import {useRouteLoaderData} from "react-router-dom";
import {LocationsSection} from "../../../../components/customer/Locations/LocationsSection";
import {NexParkLocationsSection} from "../../../../components/customer/Locations/NexParkLocationsSection";
import {ICustomer} from "../../../../model";
import {hasNexPark, hasNexResponse, hasUmojoAnalytics} from "../../../../model/api/nexParkInstance/instancesChecker";
import {BillingMode} from "../../../../model/api/customers/billing-mode";

const createSubLinks = (customer: ICustomer) => {
    const innerNavLinks: {name: string, enabled: boolean}[] = [
        {name: 'Locations', enabled: hasUmojoAnalytics(customer)},
        {name: 'NexPark Locations', enabled: hasNexPark(customer)},
        {name: 'NexResponse Locations', enabled: hasNexResponse(customer)}
    ];

    return innerNavLinks.filter((link) => link.enabled);
}


const CustomerLocationsTab = () => {
    const customer = useRouteLoaderData('customer-info') as ICustomer;
    const dynamicSubNavLinks = useMemo(() => {
        return createSubLinks(customer);
    }, [customer]);

    const [activeInnerTab, setActiveInnerTab] = useState<string>(dynamicSubNavLinks[0]?.name || '');

    const renderInnerContent = () => {
        switch (activeInnerTab) {
            case 'Locations':
                return <LocationsSection customer={customer}/>;
            case 'NexPark Locations':
                return <NexParkLocationsSection customer={customer} billingMode={BillingMode.NexPark} />
            case 'NexResponse Locations':
                return <NexParkLocationsSection customer={customer} billingMode={BillingMode.NexResponse} />
            default:
                return <div>Not Found</div>;
        }
    };

    return (
        <div className={styles.detailsLayout}>
            {dynamicSubNavLinks.length > 1 &&
                <nav className={styles.innerSidebar}>
                    <ul>
                        {dynamicSubNavLinks.map((tab) => (
                            <li key={tab.name}>
                                <button
                                    type={'button'}
                                    className={activeInnerTab === tab.name ? styles.active : ''}
                                    onClick={() => setActiveInnerTab(tab.name)}
                                >
                                    {tab.name}
                                </button>
                            </li>
                        ))}
                    </ul>
                </nav>
            }


            <div className={styles.contentWrapper}>
                <h2 style={{fontWeight: 400}}>{activeInnerTab}</h2>
                {renderInnerContent()}
            </div>
        </div>
    );
}

export default CustomerLocationsTab;
